export enum CompanyTypeEnum {
  AIRLINE = 'AIRLINE',
  FORWARDER = 'FORWARDER',
  STANDARD = 'STANDARD',
  GSA = 'GSA',
  COLOADER = 'COLOADER',
}
